<template>
	<div class="center-container">
		<h1>Sign in</h1>
		<p>Don't have an account? <router-link :to="{path: '/sign-up'}">Create one</router-link>.</p> 
		
		<form @submit.prevent="onSend">
				<label for="email">Email</label>
				<input placeholder="you@email.com" type="email" name="email" v-model="email" required>
				
				<label :style="{float: 'left', marginTop: '30px'}" for="password">Password</label>
				<router-link id="forgot-password-2" to='/forgot-password'>?</router-link>
				<span :style="{position: 'relative'}">
					<label :style="{right: '20px', top: '56px'}" class="password-toggle-container">Show/Hide Password
						<input v-on:click="togglePassword" type="checkbox">
						<span class="checkmark"></span>
					</label>
					<input type="password" name="password" v-model="password" id="login-password-2" required>
				</span>

			<button id="send-btn" class="full-width-input" type="submit">Send</button>
		</form>
	</div>
</template>
<script>
	export default 
	{
		created () 
		{
			document.title = "Sign in | Bookplate";
			try
			{
				var login = document.getElementById("login-widget");
				login.className = "";
			}
			catch(e)
			{ 
				//pass
			}
		},
		methods:
		{
			togglePassword: function ()
			{
				var input = document.getElementById("login-password-2");
				if (input.type === "password") 
				{
					input.type = "text";
				} 
				else 
				{
					input.type = "password";
				}
			},
			async onSend()
			{
				try
				{
					window.navigator.vibrate(30);
				}
				catch(e)
				{
					//pass
				}
				
				let vue = this;
				const server = new XMLHttpRequest();
				var url = 'https://api.bookplate.co/login';
				var data = {
					"email": this.email,
					"password":this.password
				};
				server.open('POST', url, true);
				server.withCredentials = true;
				server.setRequestHeader('Content-type', 'application/json');
				server.getResponseHeader('Set-Cookie');

				server.onreadystatechange = function()
				{
					if(server.readyState == 4 && server.status == 200) 
					{
						vue.$store.dispatch('saveUserLogged', server.response);
						vue.$router.push('/');
					}
					else if(server.readyState == 4 && server.status == 401)
					{
						//document.getElementById("login-password-2").style.background = "#c08989";
						document.getElementById("login-password-2").setCustomValidity("The email or password is incorrect");
						document.getElementById("send-btn").click();
					}
					else if(server.readyState == 4)
					{
						vue.$alert("Something went wrong. Please try again in a moment, or contact support@bookplate.co.", "Error: " + server.status);
					}
				}
				server.send(JSON.stringify(data));
			}
		}
	}
</script>